<script setup>
import { Icon, Button } from '@components'

const emit = defineEmits(['click'])

const props = defineProps({
    text: {
        type: String,
        default: 'Save'
    }
})
</script>

<template>
    <Button size="xl" type="primary" radius="square" classButton="w-full justify-between" @click="emit('click')">{{ props.text }}</Button>
</template>